import { mapGetters } from 'vuex';
import presets from '../views/games/puzzles/presets';

export default {
  data() {
    return {
      entity: {
        title: '',
        levels: {},
        quotes: [],
        image: null,
        default_level: null,
        puzzle: {
          public_url: '',
        },
      },
      source: {
        title: '',
        levels: {},
        quotes: [],
        image: null,
        default_level: null,
        puzzle: {
          public_url: '',
        },
      },
      imageSelected: false,
      imageOnLoadHandlerSet: false,
      imageLoaded: false,
      presets,
    };
  },

  computed: {
    ...mapGetters({
      images: 'memoryGame/imageList',
    }),
  },

  methods: {
    addQuote() {
      this.entity.quotes.push({
        text: '',
      });
      this.entity = {
        ...this.entity,
      };
      this.entity.quotes = [
        ...this.entity.quotes,
      ];
    },
    onDeleteQuote(index) {
      this.entity.quotes.splice(index, 1);
      this.entity = {
        ...this.entity,
      };
      this.entity.quotes = [
        ...this.entity.quotes,
      ];
    },
    makeOptions(preset) {
      let options = [];
      if (!this.$refs.uploader) {
        return options;
      }
      const { baseAmounts } = preset;
      const img = this.$refs.uploader.$refs.imageBoxImg;
      const { naturalWidth, naturalHeight } = img;
      const heightDivWidth = naturalHeight / naturalWidth;
      const widthDivHeight = naturalWidth / naturalHeight;
      baseAmounts.forEach((amount) => {
        let xAmount;
        let yAmount;
        if (heightDivWidth > 1) {
          xAmount = Math.round(Math.sqrt(amount) / heightDivWidth);
          yAmount = Math.round(xAmount * heightDivWidth);
        } else {
          yAmount = Math.ceil(Math.sqrt(amount) / widthDivHeight);
          xAmount = Math.ceil(yAmount * widthDivHeight);
        }
        const resultAmount = xAmount * yAmount;
        if (resultAmount >= 10 && resultAmount <= 350) {
          options.push({
            xAmount,
            yAmount,
            text: `${xAmount * yAmount} pieces (${xAmount} by width, ${yAmount} by height)`,
            type: preset.type,
          });
        }
      });
      options = this.filterDuplicates(options, item => item.xAmount);
      return options;
    },
    filterDuplicates(array, predicate) {
      const newArr = [...array];
      for (let i = 0; i < array.length - 1; i++) {
        for (let j = i + 1; j < array.length; j++) {
          const curr = array[i];
          const next = array[j];
          if (predicate(curr) === predicate(next)) {
            const index = newArr.indexOf(next);
            if (index !== -1) {
              newArr.splice(index, 1);
            }
          }
        }
      }
      return newArr;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/PuzzleGameMixin.js